var path = '/client/front-office/modules/instance/views/partials/instance-block_subtitle.html';
var html = "<!-- Instance block subtitle -->\n<div class=\"instance-block-subtitle\">\n    {{ ::vm.instance.subtitle | trans }}\n</div>\n";
window.angular.module('AppTemplates').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;